<template>
    <v-card
        class="mx-auto EK-card IMThemeGray rounded-xl rounded-tr-0 overflow-hidden text-right pb-5"
    >
        <v-card-title class="justify-content-center text-white">
            <strong>إضافة إشعار</strong>
        </v-card-title>
        <v-form @submit.prevent="submitForm" ref="notifyForm" v-model="valid">
            <v-card-text class="pb-0">
                <v-col>
                    <v-row>
                        <v-col cols="12" md="6">
                            <label for="store"
                                ><img
                                    src="/media/svg/pen-notification.svg"
                                    width="24"
                                    class="ml-2"
                                    alt="pen"
                                />اسم المشترك</label
                            >
                            <v-autocomplete
                                class="rounded-tr-0"
                                id="store"
                                auto-select-first
                                dense
                                rounded
                                color="IMThemeGray"
                                solo
                                item-color="IMThemeGray"
                                :items="[
                                    { id: 0, name: 'بلا مشترك' },
                                    ...shopList
                                ]"
                                v-model="notificationForm.shopId"
                                item-text="name"
                                item-value="id"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" md="6">
                            <label for="title"
                                ><img
                                    src="/media/svg/pen-notification.svg"
                                    width="24"
                                    class="ml-2"
                                    alt="pen"
                                />عنوان الإشعار</label
                            >
                            <v-text-field
                                v-model="notificationForm.title"
                                class="rounded-tr-0"
                                id="title"
                                dense
                                :rules="notyTitle"
                                rounded
                                solo
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                            <label for="title"
                                ><img
                                    src="/media/svg/pen-notification.svg"
                                    width="24"
                                    class="ml-2"
                                    alt="pen"
                                />عنوان الإشعار</label
                            >
                            <v-text-field
                                v-model="notificationForm.title"
                                class="rounded-tr-0"
                                id="title"
                                dense
                                :rules="notyTitle"
                                rounded
                                solo
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                            <label for="title"
                                ><img
                                    src="/media/svg/pen-notification.svg"
                                    width="24"
                                    class="ml-2"
                                    alt="pen"
                                />نص الرابط (اختياري)</label
                            >
                            <v-text-field
                                v-model="notificationForm.buttonText"
                                class="rounded-tr-0"
                                id="buttonText"
                                dense
                                 rounded
                                solo
                            ></v-text-field>
                        </v-col>

                        <v-col cols="12" md="6">
                            <label for="title"
                                ><img
                                    src="/media/svg/pen-notification.svg"
                                    width="24"
                                    class="ml-2"
                                    alt="pen"
                                />رابط  الإشعار(اختياري)</label
                            >
                            <v-text-field
                                v-model="notificationForm.buttonUrl"
                                class="rounded-tr-0"
                                id="ButtonUrl"
                                dense
                                 rounded
                                solo
                            ></v-text-field>
                        </v-col>

                        <v-col cols="12" md="6">
                            <label for="cityName">إرسال إلى مدينة معينة (اختياري)</label>
                            <v-autocomplete
                                class="rounded-tl-0"
                                id="store"
                                auto-select-first
                                dense
                                rounded
                                solo
                                color="IMThemeGray"
                                item-color="IMThemeGray"
                                :items="citiesList"
                                v-model="notificationForm.CityIdToSend"
                                item-text="name"
                                item-value="id"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="12">
                            <label for="description"
                                ><img
                                    src="/media/svg/document-notification.svg"
                                    width="24"
                                    class="ml-2"
                                    alt="pen"
                                />نص الإشعار</label
                            >
                            <v-textarea
                                v-model="notificationForm.body"
                                class="rounded-tr-0"
                                color="secondary"
                                id="description"
                                :rules="notyDesc"
                                rounded
                                solo
                            ></v-textarea>
                        </v-col>
                        <v-col cols="12">
                            <v-switch
                                v-model="ShowTimer"
                                label="تحديد التوقيت"
                                color="orange"
                                hide-details
                            ></v-switch>
                        </v-col>
                        <v-col v-if="ShowTimer">
                            <v-row>
                                <v-col cols="12" md="6" class="text-center">
                                    <label for="date"
                                        >تاريخ إرسال الإشعار</label
                                    >
                                    <v-menu
                                        v-model="menu2"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="auto"
                                    >
                                        <template
                                            v-slot:activator="{ on, attrs }"
                                        >
                                            <v-text-field
                                                v-model="notificationForm.date"
                                                prepend-icon="mdi-calendar"
                                                readonly
                                                v-bind="attrs"
                                                v-on="on"
                                                rounded
                                                solo
                                                :rules="[
                                                    v =>
                                                        !!v ||
                                                        'يرجى اختيار تاريخ إرسال'
                                                ]"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                            v-model="notificationForm.date"
                                            @input="menu2 = false"
                                        ></v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col cols="12" md="6" class="text-center">
                                    <label for="time">التوقيت</label>
                                    <v-menu
                                        ref="menu3"
                                        v-model="menu3"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        :return-value.sync="
                                            notificationForm.time
                                        "
                                        transition="scale-transition"
                                        offset-y
                                        max-width="290px"
                                        min-width="290px"
                                    >
                                        <template
                                            v-slot:activator="{ on, attrs }"
                                        >
                                            <v-text-field
                                                v-model="notificationForm.time"
                                                prepend-icon="mdi-clock-outline"
                                                readonly
                                                v-bind="attrs"
                                                v-on="on"
                                                rounded
                                                solo
                                                :rules="[
                                                    v =>
                                                        !!v ||
                                                        'يرجى اختيار توقيت للإشعار'
                                                ]"
                                            ></v-text-field>
                                        </template>
                                        <v-time-picker
                                            v-if="menu3"
                                            v-model="notificationForm.time"
                                            ampm-in-title
                                            format="ampm"
                                            @click:minute="
                                                $refs.menu3.save(
                                                    notificationForm.time
                                                )
                                            "
                                        ></v-time-picker>
                                    </v-menu>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-col>
            </v-card-text>
            <v-card-actions class="justify-content-center">
                <v-btn
                    type="submit"
                    rounded
                    :disabled="!valid"
                    class="by-5 px-10 rounded-tr-0"
                >
                    تم
                </v-btn>
            </v-card-actions>
        </v-form>
    </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
    computed: {
        ...mapGetters(["citiesList"])
    },
    data: () => ({
        shopNames: [],
        menu2: null,
        menu3: null,
        time: null,
        ShowTimer: false,
        shopId: Number,
        notificationForm: {},
        valid: false,
        notyTitle: [v => !!v || "يرجى اختيار عنوان للإشعار"],
        notyDesc: [v => !!v || "يرجى اختيار نص للإشعار"],
        selectCityFor: [v => !!v || "يرجى اختيار مدينة"]
    }),
    created() {
        this.fetchCitiesList();
        console.log(this.shopList);
        this.$store.dispatch("setBreadcrumbs", [
            {
                text: "الإشعارات",
                disabled: false,
                href: "/notification"
            },
            {
                text: "إضافة إشعار",
                disabled: false
            }
        ]);
    },
    props: {
        shopList: Array
    },
    methods: {
        ...mapActions(["fetchCitiesList"]),
        close() {
            this.$emit("close");
            this.$refs.notifyForm.reset();
        },
        submitForm() {
            this.$store.dispatch("setNotification", this.notificationForm);
            this.close();
        }
    }
};
</script>
